import { Component, input, model, output } from '@angular/core';
import { ExpandedPrintVariation } from '../../../models/client-models/entities/expanded-print-variation';

@Component({
  selector: 'app-variation-selection',
  templateUrl: './variation-selection.component.html',
  styleUrls: ['./variation-selection.component.scss'],
  standalone: false,
})
export class VariationSelectionComponent {
  selectedVariation = model<ExpandedPrintVariation | null>(null);

  printVariations = input.required<ExpandedPrintVariation[]>();

  doNextStep = output<void>();

  constructor() {}

  noVarations() {
    return this.printVariations().length === 0;
  }

  onVariationClick(variation: ExpandedPrintVariation) {
    this.selectedVariation.set(variation);
  }

  onDoubleClick() {
    this.doNextStep.emit();
  }
}
